import { vuexLogistic } from '@/store/compositionV2/module/logistic'
import { LogisticWaybillApi } from '@/api/Logistic'

const state = () => ({
  ...vuexLogistic.createState(),
  api: LogisticWaybillApi,
  expand: 'driver,transport,work,fuel_balance',
  namePageDetailed: 'LogisticWaybillUpdate',
  tableHeaders: [
    {
      title: '№ путевого листа',
      isSortable: true,
      sortName: 'code'
    },
    {
      title: 'Водитель',
      isSortable: true,
      sortName: 'driver.full_name'
    },
    {
      title: 'Старт работ',
      isSortable: true,
      sortName: 'start_at'
    },
    {
      title: 'Окончание работ',
      isSortable: true,
      sortName: 'end_at'
    },
    {
      title: 'Начальный пробег',
      isSortable: true,
      sortName: 'distance_start'
    },
    {
      title: 'Конечный пробег',
      isSortable: true,
      sortName: 'distance_end'
    },
    {
      title: 'Топливо нач.знач./кон.знач.',
      isSortable: false
    },
    {
      title: 'Техника',
      isSortable: true,
      sortName: 'transport.name'
    },
    {
      title: 'Дата путевого листа',
      isSortable: true,
      sortName: 'date_at'
    }
  ],
  filterValue: {},
  filterIsActive: false
})

const getters = {
  ...vuexLogistic.createGetters(),
  getList: state => {
    return state.list.map(item => {
      return {
        isControlsActive: item.isControlsActive,
        isActive: item.isActive,
        id: item.id,
        values: [
          item.code,
          item.driver.full_name,
          { data: item.start_at, mod: 'date' },
          { data: item.end_at, mod: 'date' },
          item.distance_start || '-',
          item.distance_end || '-',
          { data: item.fuel_balance ? item.fuel_balance : '-', mod: 'fuel' },
          `${item.transport.name} (${item.transport.number})`,
          { data: item.date_at, mod: 'date-simple' }
        ]
      }
    })
  }
}

const mutations = {
  ...vuexLogistic.createMutations()
}

const actions = {
  ...vuexLogistic.createActions()
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
